import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { EnvService } from './env.service';

@Injectable({
  providedIn: 'root'
})
export class UploadFileService {

  constructor(public http: HttpClient, private env: EnvService) { }

  // headers = new HttpHeaders().set('Content-Type', 'application/json');

  upload(file: any): Observable<any> {
    const formData = new FormData();
    formData.append('file', file, file.name);
    return this.http.post(`${this.env.URL_API}/subir_archivo_adjunto`, formData);
  }

}
